import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './Register.css';
import logo from '../assets/img/theme/tzone-logo-450x200.png';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n, useTranslation } from '../i18n';
import API_BASE_URL from '../config/api';

const Register = () => {
  const { t } = useTranslation();
  const { language } = useI18n();
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
    role: '',
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRoleSelection = (role) => {
    setFormData({ ...formData, role });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage(t('register.passwordsDontMatch'));
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/register`, { 
		  
		
        ...formData,
        preferredLanguage: language,
      }, {
        headers: { 'Accept-Language': language },
      });

      const { user } = response.data;

      localStorage.setItem('userId', user.id);
      localStorage.setItem('userRole', user.role);
      if (user.name) localStorage.setItem('userName', user.name);
      if (user.email) localStorage.setItem('userEmail', user.email);
      localStorage.setItem('language', user.preferredLanguage || language);

      const nextRoute = user.role === 'trainer' ? '/trainer-profile' : '/athlete-profile';
      navigate(nextRoute);
    } catch (error) {
      setMessage(error.response?.data?.error || t('register.submitError'));
    }
  };

  return (
    <div className="register-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <LanguageSwitcher dark />
      </div>

      <div className="register-logo">
        <img src={logo} alt="TZone Logo" />
      </div>

      <form className="register-form" onSubmit={handleSubmit}>
        <div className="register-top-row">
          <button type="button" className="register-back-button" onClick={() => navigate('/')}>
            ← {t('common.backToHome')}
          </button>

          <span className="register-have-account">
            {t('register.alreadyHaveAccount')}{' '}
            <Link to="/login" className="register-login-link">
              {t('register.loginLink')}
            </Link>
          </span>
        </div>

        <h2>{t('register.title')}</h2>

        <label>{t('register.name')}:</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label>{t('register.lastName')}:</label>
        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />

        <label>{t('common.email')}:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label>{t('common.username')}:</label>
        <input type="text" name="username" value={formData.username} onChange={handleChange} required />

        <label>{t('common.password')}:</label>
        <input type="password" name="password" value={formData.password} onChange={handleChange} required autocomplete="new-password" />

        <label>{t('common.confirmPassword')}:</label>
        <input
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
          autoComplete="new-password"
        />

        <label>{t('register.selectRole')}:</label>
        <div className="role-buttons">
          <button
            type="button"
            className={formData.role === 'athlete' ? 'selected' : ''}
            onClick={() => handleRoleSelection('athlete')}
          >
            {t('common.athlete')}
          </button>
          <button
            type="button"
            className={formData.role === 'trainer' ? 'selected' : ''}
            onClick={() => handleRoleSelection('trainer')}
          >
            {t('common.trainer')}
          </button>
        </div>

        <button type="submit" disabled={!formData.role}>
          {t('common.register')}
        </button>

        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default Register;
